__turbopack_context__.v({
  "dropdown": "transactions-tools-module-sass-module__dAX7Qq__dropdown",
  "tools": "transactions-tools-module-sass-module__dAX7Qq__tools",
});
